import {
  FETCH_LINES_REQUEST,
  FETCH_LINES_SUCCESS,
  FETCH_LINES_FAILURE,
  FETCH_LINE_REQUEST,
  FETCH_LINE_SUCCESS,
  FETCH_LINE_FAILURE,
  UPDATE_LINES_REQUEST,
  UPDATE_LINES_FAILURE,
  UPDATE_LINES_SUCCESS,
  DELETE_LINES_REQUEST,
  DELETE_LINES_FAILURE,
  DELETE_LINES_SUCCESS,
  CLEAR_LINE_ERRORS,    // Nouvelles imports
  CLEAR_LINE_SUCCESS,
} from './actionTypes';

const initialState = {
  lines: [],
  line: null,
  loadingLine: false,
  errorLine: null,
  lineAdded: null
};

const Lines = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LINES_REQUEST:
      return {
        ...state,
        loadingLine: true,
        errorLine: null,
        lineAdded: false
      };
    case FETCH_LINES_SUCCESS:
      return {
        ...state,
        loadingLine: false,
        lines: action.payload,
      };
    case FETCH_LINES_FAILURE:
      return {
        ...state,
        loadingLine: false,
        errorLine: action.payload,
      };
    case FETCH_LINE_REQUEST:
      return {
        ...state,
        loadingLine: true,
        errorLine: null,
        lineAdded: false
      };
    case FETCH_LINE_SUCCESS:
      return {
        ...state,
        loadingLine: false,
        line: action.payload,
      };
    case FETCH_LINE_FAILURE:
      return {
        ...state,
        loadingLine: false,
        errorLine: action.payload,
      };
    case UPDATE_LINES_REQUEST:
      return {
        ...state,
        loadingLine: true,
        errorLine: null,
        lineAdded: false
      };
    case UPDATE_LINES_SUCCESS:
      return {
        ...state,
        loadingLine: false,
        line: null,
        lineAdded: true
      };
    case UPDATE_LINES_FAILURE:
      return {
        ...state,
        loadingLine: false,
        errorLine: action.payload,
      };
    case DELETE_LINES_REQUEST:
      return {
        ...state,
        loadingLine: true,
        errorLine: null,
        lineAdded: false
      };
    case DELETE_LINES_SUCCESS:
      return {
        ...state,
        lineAdded: true,
        loadingLine: false,
        lines: state.lines.filter(line => line.id !== action.payload),
      };
    case DELETE_LINES_FAILURE:
      return {
        ...state,
        loadingLine: false,
        errorLine: action.payload,
      };
    case CLEAR_LINE_ERRORS:
      return {
        ...state,
        errorLine: null,
      };
    case CLEAR_LINE_SUCCESS:
      return {
        ...state,
        lineAdded: null,
      };
      
    default:
      return state;
  }
};

export default Lines;